module.exports = __webpack_public_path__ + "static/img/mp2.2cacf54f.png";